// extracted by mini-css-extract-plugin
export default {"selectWrapper":"Ebooks_selectWrapper__MTVXM","selectDropdown":"Ebooks_selectDropdown__Qefcq"};